import type { HTMLAttributes } from 'react';
import type { AIconProps } from '../../atoms/AIcon/AIcon.types';
import type { ATextInteractiveProps } from '../../atoms/ATextInteractive/ATextInteractive.types';
import type { ABodyProps } from '../../atoms/ABody/ABody.types';

export enum MListIconDetailSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export interface MListIconDetailProps extends HTMLAttributes<HTMLDivElement> {
  size?: MListIconDetailSize;
  trailingIcon?: string | boolean;
  aIcon?: Partial<AIconProps>;
  aIcon2?: Partial<AIconProps>;
  aTextInteractive?: Partial<ATextInteractiveProps>;
  aBody?: Partial<ABodyProps>;
}
